'use strict';

/* globals config */

require([config.relative_path + '/plugins/nodebb-plugin-lessons/static/vendor/vue.js'], function (Vue) {
	Vue.component('answer-edit', {
		props: ['answer', 'index', 'remove', 'answerTypes', 'initData'],
		data: function () {
			return {
				answerComponent: this.answer.type + '-answer-edit',
				type: '',
			};
		},
		mounted: function () {
			var me = this;

			this.type = this.answerTypes.find(function (item) { return item.type == me.answer.type; });
		},
		template:
		'<div class="list-group-item">' +
			'<div class="row">' +
				'<div class="col-md-1 text-center">' +
					'<h1>{{index + 1}}</h1>' +
					'<h2><i :class="type.icon"></i></h2>' +
					'<span class="badge badge-primary">{{type.name}}</span>' +
				'</div>' +
				'<div class="col-md-11">' +
					'<div class="fg-line mb-5">' +
						'<label for="name">{{initData.translations.internalName}}</label>' +
						'<input type="text" class="form-control" v-model="answer.name" :placeholder="initData.translations.internalNamePlaceholder" />' +
						'<small>{{initData.translations.onlyForAnalytics}}</small>' +
					'</div>' +
					'<div :is="answerComponent" :answer="answer" class="mb-4" :init-data="initData"></div>' +
					'<label class="d-block mb-2"><input type="checkbox" v-model="answer.isValid" /> {{initData.translations.validAnswer}}</label>' +
					'<button class="btn btn-danger btn-xs" type="button" v-on:click="remove(answer)">{{initData.translations.removeAnswer}}</button>' +
				'</div>' +
			'</div>' +
		'</div>',
	});
});
